import { render, staticRenderFns } from "./RowBlockWritingOffCommissionTourism.vue?vue&type=template&id=5f65fc66&"
import script from "./RowBlockWritingOffCommissionTourism.vue?vue&type=script&lang=js&"
export * from "./RowBlockWritingOffCommissionTourism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports